import {
  AppBar,
  Box,
  Button,
  Container,
  Link,
  Stack,
  Toolbar,
} from '@mui/material'

import { Logo } from 'lib/components/CustomIcons'

import ScrollTranformation from './ScrollTranformation'
import MenuDrawer from './MenuDrawer'

function Bar(props) {
  const {
    appBarStyles,
    homeHref,
    logoStyles,
    navigation,
    showLogo,
  } = props

  return (
    <AppBar {...appBarStyles} >
      <Container disableGutters maxWidth="xl">
        <Toolbar>
          <Box sx={{ flexGrow: 1, pt: 2 }}>
            {showLogo && (
              <Link
                href={homeHref}
                underline="none"
              >
                <Logo {...logoStyles} />
              </Link>
            )}
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }}}>
            <Stack spacing={1} direction="row">
              {navigation.map(({ anchor, text, options }) => (
                <Button
                  href={anchor}
                  key={anchor}
                  {...options}
                >
                  {text}
                </Button>
              ))}
            </Stack>
          </Box>

          <MenuDrawer navigation={navigation} />
        </Toolbar>
      </Container>
    </AppBar>
  )
}

const Navbar = ({ navigation = [], homeHref = '/', showLogo = true, navbarBackgroundColor }) => (
  <ScrollTranformation navbarBackgroundColor={navbarBackgroundColor}>
    <Bar navigation={navigation} homeHref={homeHref} showLogo={showLogo} />
  </ScrollTranformation>
)

export default Navbar
